// Copyright 2025-2026 Florian Gallon. All Rights reserved.
import { Check, ArrowRight } from 'lucide-react';

export default function FinalCta({ isFr, setView }) {
  const points = isFr
    ? ['Boutique en ligne incluse', 'Enregistrements de traçabilité', 'Sans carte bancaire']
    : ['Online shop included', 'Traceability records', 'No credit card needed'];

  return (
    <section className="dbk-final">
      <div className="dbk-wrap">
        <h2 className="dbk-h2">
          {isFr
            ? 'Prêt à réunir votre boulangerie dans un seul outil ?'
            : 'Ready to bring your bakery into one place?'}
        </h2>
        <p className="dbk-final__lede">
          {isFr
            ? 'Planification de production, ventes en ligne et traçabilité complète, au même endroit. Essayez gratuitement pendant 30 jours.'
            : 'Production planning, online sales and complete traceability, in one place. Try it free for 30 days.'}
        </p>

        <button
          type="button"
          className="dbk-btn dbk-btn--on-dark"
          onClick={() => setView('signup-baker')}
        >
          {isFr ? 'Commencer l’essai de 30 jours' : 'Start your 30-day trial'}
          <ArrowRight size={18} strokeWidth={2} />
        </button>

        <ul className="dbk-final__points">
          {points.map((p) => (
            <li key={p}><Check size={15} strokeWidth={2.25} />{p}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
